module.exports = __webpack_public_path__ + "static/media/8.df10126c.jpg";